import React, { Component } from 'react';
import config from '../config';
import { Redirect } from 'react-router-dom';

class Step1 extends Component {
    constructor(props) {
        super(props);
        
        this.state = {
            nextStep: false
        }
    }

    nextStep = (e) => {
        this.setState({nextStep: true});
    }

    render() {
        if (this.state.nextStep)
            return (<Redirect push to='/step2' />);

        return (
            <div>
                {
                    (config.environment.authorizeNet.keyCode === "prod") ? null : 
                        <h1 style={{color: "red"}}>{config.environment.authorizeNet.keyCode} {config.environment.authorizeNet.keyCode} {config.environment.authorizeNet.keyCode} {config.environment.authorizeNet.keyCode}</h1>
                }

                <p>
                The Recording Academy is pleased to offer customized certificates which recognize those who participated in or contributed to a GRAMMY-winning or GRAMMY-nominated recording.
                </p>

                <p><strong><u>Important: Please Read</u></strong><br />
                    The Participation Certificate orders system is open from <strong>Tuesday, March 10, 2026</strong> to <strong>Tuesday, June 30, 2026</strong>.</p>
                <p><strong>You may be in line to receive a Nominee or Achievement certificate at no cost, depending on the category and credit. </strong> 
                    Prior to ordering a Participation certificate, please check our online rulebook 
                    <a href="https://naras.a.bigcontent.io/v1/static/68_Rulebook_07.28.2025" target="_blank" rel="noopener noreferrer"> here</a>, beginning on page 61, to see if your credit qualifies. 
                    We do not offer refunds if you purchase duplicate certificates. </p>

                <p><strong>Who is eligible?</strong><br />
                Musicians, composers, publishers, studios, and labels may apply for a participation certificate with proof of participation in a GRAMMY-winning or GRAMMY-nominated recording.</p>

                <p><em><u>Please note that all requests are pending on approval. Your money will be refunded if we deny your application.</u></em></p>
                
                <p><strong>What do I get?</strong><br />
                Certificates are 8.5" x 11" with customized information. Certificates are printed on heavy, ivory stock, embossed with the official GRAMMY logo in gold & black foil. Certificates are shipped unframed.</p>

                <p><strong>What Documents do I need to order?</strong></p>
                <ul>
                    <li>Official product liner notes or professional service crediting you with the role. Upload PDF, scan, or clear photo. <u>Pertinent information like album or song title and artist name needs to appear on the file uploaded</u>.</li>
                    <li>We accept Professional Service Crediting from: <strong>Muso.ai, AllMusic, Discogs, Tidal,  Spotify, and Apple Music.</strong></li>
                    <li><strong>No</strong> emails, text messages, or other <strong>non-official</strong> forms of documentation.</li>
                </ul>

               <p> <strong>Cost</strong><br />
               Certificates are ${config.environment.application.certificatePrice}.00 each (Includes tax and shipping)<br />
               <strong>We accept major credit cards.</strong></p>

                <p>Please allow <strong>6-10 weeks</strong> for delivery.</p>

                <p>For questions: <a href="mailto:ParticipationCertificate@recordingacademy.com">ParticipationCertificate@recordingacademy.com</a></p>

                <p>&nbsp;</p>

                <p><input type="button" onClick={this.nextStep} className="btn btn-primary form-control" value="Apply For Participation Certificate" /></p>

            </div>
        );
    }
}

export default Step1;